import React, { useEffect, useMemo, useState } from 'react';
import { Text, View, TextInput, StyleProp, TextStyle } from 'react-native';

import { isWeb } from '@helpers';
import { font } from '@styles/fonts';

import ToggleSwitch from '@v2/elements/ToggleSwitch';

import { RightPartType, TextShowFormatType } from '@v2/elements/Fields/interfaces';
import { webTimeCalculation } from '@services/webTimeCalculation';
import { secondsToInputDisplay } from '@v2/helpers/time';
import { scale } from '@components/frame';

const TextShowFormat = ({ VALUE_ALIGN, value, C }: TextShowFormatType) => (
  <Text style={[font.Body, { color: C('Label/Light/Tertiary'), textAlign: VALUE_ALIGN, justifyContent: 'center' }]}>{value}</Text>
);

export default ({
  TYPE,
  VARIANT,
  VALUE_ALIGN,
  value,
  UPDATE,
  placeholder,
  C,
  VALUE_ALIGN_FLEX,
  mainColor,
  disabled,
  setRightPartWidth,
}: RightPartType) => {
  const [localValue, setLocalValue] = useState(value ? secondsToInputDisplay(Number(value)) : value);

  const [switchLocalValue, setSwitchLocalValue] = useState<boolean>(!!value);

  useEffect(() => {
    setSwitchLocalValue(!!value);
  }, [value]);

  // Sync localValue when value prop changes (e.g., when switching from Show to Edit mode)
  useEffect(() => {
    if (TYPE === 'Key-Value time 0:00:00' && value !== null && value !== undefined) {
      setLocalValue(secondsToInputDisplay(Number(value)));
    }
  }, [value, TYPE]);

  const TextInputStyles = [
    isWeb && {
      // @ts-ignore
      outline: 0,
      border: 'none',
    },
    font.Body,
    {
      color: C('Label/Dark/Primary'),
      textAlign: VALUE_ALIGN,
      maxWidth: scale(70),
    },
  ] as StyleProp<TextStyle>;
  console.log(value, 'value');
  const content = useMemo(() => {
    switch (TYPE) {
      case 'Key-Value time 0:00:00': {
        switch (VARIANT) {
          case 'Show': {
            return <TextShowFormat {...{ VALUE_ALIGN, value, C }} />;
          }
          case 'Edit': {
            return (
              <View style={{ flex: 1, alignItems: VALUE_ALIGN_FLEX, justifyContent: 'center' }}>
                <TextInput
                  value={localValue == null ? '' : String(localValue)}
                  onChangeText={setLocalValue}
                  placeholder={placeholder}
                  placeholderTextColor={C('Label/Light/Quinary')}
                  style={TextInputStyles}
                  onBlur={() => {
                    if (localValue === '' || disabled) {
                      return;
                    }
                    const seconds = webTimeCalculation(localValue);
                    setLocalValue(secondsToInputDisplay(seconds));
                    UPDATE(seconds);
                  }}
                  editable={!disabled}
                />
              </View>
            );
          }
        }
      }
      case 'Key-Value': {
        switch (VARIANT) {
          case 'Show': {
            return <TextShowFormat {...{ VALUE_ALIGN, value, C }} />;
          }
          case 'Edit': {
            return (
              <View style={{ flex: 1, alignItems: VALUE_ALIGN_FLEX, justifyContent: 'center' }}>
                <TextInput
                  value={String(value)}
                  onChangeText={UPDATE}
                  placeholder={placeholder}
                  placeholderTextColor={C('Label/Light/Quinary')}
                  style={TextInputStyles}
                  editable={!disabled}
                />
              </View>
            );
          }
        }
      }
      case 'Key-Switch - Phone': {
        return (
          <View style={{ flex: 1, alignItems: VALUE_ALIGN_FLEX, justifyContent: 'center' }}>
            <ToggleSwitch
              size="medium"
              onToggle={(updatedValue: boolean) => {
                setSwitchLocalValue(updatedValue);
                UPDATE(!updatedValue); // we save in store and send to backend manual state whereas current state stores automatic state
              }}
              isOn={switchLocalValue}
              onColor={mainColor}
              disabled={disabled}
            />
          </View>
        );
      }
    }
  }, [value, localValue, disabled, switchLocalValue]);

  return (
    <View
      onLayout={(event) => {
        const width = event.nativeEvent.layout.width;
        setRightPartWidth(width);
      }}
    >
      {content}
    </View>
  );
};
